export const EVENT_BUS_SESSION_RESOURCES_CHANGED = 'gd.session.resources:change'
